import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { AbsoluteValuePipe } from '../../pipes';
import { RouterLink } from '@angular/router';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { IPriceColumnBlok } from './price-column.model';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { CurrencyPipe, NgClass } from '@angular/common';

@Component({
    selector: 'app-price-column',
    imports: [AbsoluteValuePipe, RouterLink, CmsComponent, NgClass, CurrencyPipe],
    templateUrl: './price-column.component.html',
    styleUrl: './price-column.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': 'containerClasses()',
    },
})
export class PriceColumnComponent {
    private _tailwind = inject(TailwindService);
    readonly baseClass = 'app-price-column';

    block = input.required<IPriceColumnBlok>();

    containerClasses = computed<string[]>(() => {
        const block = this.block();
        return [
            this.baseClass,
            this.baseClass + '-background--' + block.backgroundColor,
            this.baseClass + '-border-radius--' + block.borderRadius,
            this.baseClass + '-padding--' + block.padding,
            ...this._tailwind.getDisplayClasses(block),
        ];
    });
}
